import type { AnalyticsContextType } from '@lib/analytics-events';

/**
 * Map a browser pathname to its `AnalyticsContextType` discriminator.
 *
 * Used by both the standardized `useAmplitudeTracking` pipeline and the
 * maintenance takeover (which fires analytics outside the hook path so
 * test coverage can exercise the takeover_shown event end-to-end during
 * outages). Keep the two callsites in sync by going through this helper
 * instead of duplicating the prefix match.
 */
export const getContextTypeFromPathname = (pathname: string): AnalyticsContextType => {
  if (pathname.startsWith('/questions/')) return 'question';
  if (pathname.startsWith('/events/')) return 'event';
  if (pathname.startsWith('/profile/')) return 'profile';
  if (pathname.startsWith('/chat/')) return 'chat';
  if (pathname.startsWith('/settings')) return 'settings';
  if (pathname.startsWith('/signup')) return 'signup';
  if (pathname.startsWith('/home')) return 'feed';
  return 'unknown';
};

export type { AnalyticsContextType };
